<template>
  <div class="create-account">
   
    <form class="form-signup" @submit.prevent="createAccount">
      <img class="mb-4" src="../assets/create-account.svg" alt width="72" height="72">
      <h1 class="h3 mb-3 font-weight-normal">Registrarse</h1>
        <small style="">Los campos marcados con asterísco(*) son obligatorios</small>
        <br>
      <div class="row">
        <div class="col-md mb-3">
          <input
            type="text"
            class="form-control"
            v-model="client_email"
            id="email"
            placeholder="Dirección de correo electrónico*"
            minlength="6"
            pattern="[^@\s]+@[^@\s]+\.[^@\s]+" title="Ingrese un e-mail válido como: example@example.com"  maxlength="255" required
            >
          <div class="invalid-feedback">El correo electrónico es requerido.</div>
        </div>
      </div>

      <div class="row">
        <div class="col-md mb-3">
          <input
            type="text"
            class="form-control"
            v-model="client_username"
            id="username"
            placeholder="Nombre de usuario*"
            maxlength="24"
            pattern="[A-Za-z0-9]{4,24}" title="Sólo se permiten letras (mayúsculas y minúsculas) y números. Puede ingresar un mínimo de 4 caracteres y un máximo de 24" 
            required>
          <div class="invalid-feedback">El nombre de usuario es requerido.</div>
        </div>

        <div class="col-md mb-3">
          <input
            type="password"
            class="form-control"
            id="password"
            placeholder="Contraseña*"
            value
            v-model="client_password"
            maxlength="255" minlength="6" title="Sólo se permiten letras (mayúsculas y minúsculas) y números. Puede ingresar un mínimo de 6 caracteres y un máximo de 255" 
            required>
          <div class="invalid-feedback">La contraseña es requerida.</div>
        </div>
      </div>

      <div class="hrdivider">
        <hr/>
        <span>Información</span>
      </div>

      <div class="row">
        <div class="col-md-6 mb-3">
          <input
            type="text"
            class="form-control"
            id="firstName"
            placeholder="Nombre*"
            v-model="client_name"
            maxlength="24"
            minlength="2"
            required>
          <div class="invalid-feedback">El nombre es requerido.</div>
        </div>

        <div class="col-md-6 mb-3">
          <input
            type="text"
            class="form-control"
            v-model="client_lastname"
            id="lastName"
            placeholder="Apellido*"
            maxlength="24"
            minlength="2"
            required>
          <div class="invalid-feedback">El apellido es requerido.</div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 mb-3">
          <input
            type="text"
            class="form-control"
            id="dni"
            placeholder="DNI"
            maxlength="8"
            pattern="[0-9]{8}" title="Sólo se permiten números. Debe ingresar un DNI válido." 
            v-model="client_dni">
        </div>

        <div class="col-md-6 mb-3">
          <input
            type="text"
            class="form-control"
            id="phone"
            placeholder="Teléfono"
            maxlength="11"
            pattern="[0-9]{7,11}" title="Sólo se permiten números. Debe ingresar un teléfono válido." 
            v-model="cliente_phone"
            >
          <div class="invalid-feedback">El número de teléfono es requerido.</div>
        </div>
      </div>

      <div class="row">
        <div class="col-md mb-3">
          <select v-model="cboDepartamento" id="basicSelect" :plain="true" @change="(event) => callProvincias(cboDepartamento)" class="form-control">
            <option disabled value="">Seleccione Departamento</option>
            <option v-for="depa in depas_array" :key="depa.id_departament" :value="depa.id_departament">{{depa.desc_departament}}</option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="col-md mb-3">
          <select v-model="cboProvincia" id="basicSelect" :disabled="isdisabled" :required="isdisabled" :plain="true" @change="(event) => callDistritos(cboProvincia)" class="form-control">
            <option disabled value="">Seleccione Provincia</option>
            <option v-for="provincia in province_array" :key="provincia.id_province" :value="provincia.id_province">{{provincia.desc_province}}</option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="col-md mb-3">
          <select v-model="cboDistrito" id="basicSelect" :disabled="isdisabled_distrito" :required="isdisabled_distrito" :plain="true" @change="(event) => enableDireccion()" class="form-control">
            <option disabled value="">Seleccione Distrito</option>
            <option v-for="distrito in distrito_array" :key="distrito.id_district" :value="distrito.id_district">{{distrito.desc_district}}</option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="col-md mb-3">
          <input
            type="text"
            class="form-control"
            v-model="client_address"
            id="emailId"
            placeholder="Dirección"
            minlength="10"
            maxlength="255"
            :required="!isdisabled_direccion"
            :disabled="isdisabled_direccion">
        </div>
      </div>

      <small><strong>NOTA: Solo los campos con asterísco (*) son obligatorios, sin embargo, si desea realizar una compra o un pedido online se le solicitará llenar todos los datos con la finalidad de brindarle un servicio adecuado.</strong></small>
      
      <div class="col-xs-12 text-center">
            <div class="mensaje-obligatorio">* Los campos marcados con asterisco son obligatorios.</div>
            <p>
              <input type="checkbox" id="checkbox" class="contact-inline" v-model="checked"> 
              <small><strong>
                He leido y estoy de acuerdo con las <a @click="show_politicas_privacidad" style="color: #d02031; cursor: pointer;">políticas de privacidad</a> de Armaq.
              </strong></small>
            </p>

            <span style="color: rgb(130,132,138); font-size: 12px;" v-if="show_politicas">En cumplimiento con lo señalado en el artículo 6 de la Ley de Protección de Datos Personales, ponemos en su conocimiento que los datos personales brindados a ARMAQ S.A., solo serán empleados para el envío de ofertas y novedades para nuestros Clientes. Los mismos serán resguardados únicamente para tal fin por ARMAQ S.A., en estricto seguimiento del artículos 9 y 11 de la norma anteriormente citada.</span>
            <br>
          </div>
     
      <button class="btn btn-lg btn-primary btn-block" type="submit" :disabled="!checked">
        <i class="fa fa-spinner fa-spin mr-1" v-if="showLoader"></i>Registrar
      </button>
    </form>
     <div class="col">
           <div :class="[(mensaje === '') ? 'd-none' : 'alert alert-success']" role="alert"><button type="button" class="close" data-dismiss="alert" @click="ocultar()">&times;</button><strong>{{ mensaje }}</strong></div>
           <div :class="[(mensaje_error === '') ? 'd-none' : 'alert alert-danger']" role="alert"><button type="button" class="close" data-dismiss="alert" @click="ocultar()">&times;</button><strong>{{ mensaje_error }}</strong></div>
      </div>
  </div>
</template>

<script>
import Vue from 'vue'
import toastr from 'toastr'
import axios from 'axios'
import { successToaster, errorToaster } from "./shared/service/ErrorHandler.js";
import {config_settings} from '../config.js'

  //HTTP ERROR STATUS
  const NOT_FOUND = 404;
  const BAD_REQUEST = 400;
  const UNAUTHORIZED = 401;
  const CONFLICT = 409;
  const INTERNAL_SERVER_ERROR = 500;

export default {
  name: "CreateAccount",
  created() {
    this.callDepartamentos();
  },
  data() {
    return {
      mensaje: "",
      mensaje_error: "",
      showLoader: false,
      client_email: "",
      client_username: "",
      client_password: "",
      client_name: "",
      client_lastname: "",
      client_dni: "",
      cliente_phone: "",
      cboDepartamento: "",
      cboProvincia: "",
      cboDistrito: "",
      client_address: "",
      cboDepartamento: "",
      cboProvincia: "",
      cboDistrito: "",
      depas_array: [],
      province_array: [],
      distrito_array: [],
      isdisabled: true,
      isdisabled_distrito: true,
      isdisabled_direccion: true,
      checked: false,
      show_politicas: false,
      token: localStorage.getItem('access_token'),
      refresh_token: localStorage.getItem('refresh_token')
    };
  },
  methods: {

    refreshToken(){
          var refresh_token = localStorage.getItem('refresh_token');
          var refresh_credentials = new FormData();
          refresh_credentials.append('grant_type', 'refresh_token');
          refresh_credentials.append('refresh_token',  refresh_token);
          refresh_credentials.append('id_store',  config_settings.STORE);

          const refreshingCall = axios({
            method: 'post',
            url: config_settings.AUTH_SERVER_URL+'/oauth/token',
            data: refresh_credentials,
            withCredentials: true,
            auth: {
                username: 'USER_CLIENT_APP',
                password: 'password'
            }})
            .then(response => {
              localStorage.setItem('access_token', response.data.access_token);
              localStorage.setItem('refresh_token', response.data.refresh_token);
              return Promise.resolve(true);
            });
            return refreshingCall;
    },

    login(user,pass){
      
      this.showLoader = true;
      var body_credentials = new FormData();
      body_credentials.append('grant_type', 'password');
      body_credentials.append('username', user);
      body_credentials.append('password', pass);
      body_credentials.append('id_store', config_settings.STORE);

      axios({
        method: 'post',
        url: config_settings.AUTH_SERVER_URL + '/oauth/token',
        data: body_credentials,
        withCredentials: true,
        auth: {
          username: 'USER_CLIENT_APP',
          password: 'password'
        }})
        .then(response => {
          var token = response.data.access_token;
          var refresh_token = response.data.refresh_token;
          localStorage.setItem('access_token', token);
          localStorage.setItem('refresh_token', refresh_token);

          this.showLoader = false;
          location.href = "/"
          console.log('¡Cuenta creada!');
        })
        .catch(error => {
          this.showLoader = false;
          this.mensaje = "";
          this.mensaje_error = "Clave y/o usuario no coinciden. Ingrese nuevamente su usuario y contraseña.";

          //console.log(error);
        });
    },

    show_politicas_privacidad() {
      if(this.show_politicas) { this.show_politicas = false }
      else { this.show_politicas = true }
    },

    createAccount() {
      this.showLoader = true;
      var distrito_json = ""
      var direccion_json = " "
      var dni_json = " "
      var phone_json = " "

      this.cboDistrito != "" ? distrito_json = { "id_district" : this.cboDistrito } : distrito_json = { "id_district" : null };
      this.client_address != "" ? direccion_json = this.client_address : direccion_json = " "
      this.client_dni != "" ? dni_json = this.client_dni : dni_json = null
      this.cliente_phone != "" ? phone_json = this.cliente_phone : phone_json = null

      var json_data = {
          "nick_client": this.client_username,
          "dni_client" : dni_json,
          "name_client": this.client_name,
          "surname_client": this.client_lastname,
          "address_client": direccion_json,
          "email_client": this.client_email,
          "phone_client": phone_json,
          "id_district": distrito_json,
          "state": {
              "id_state": 1
          },
          "password_client": this.client_password,
          "photo_client" : "clients/empty-img"
      }

      axios({
        method: 'post',
        url: config_settings.RESOURCE_SERVER_URL+'/POST/clients',
        data: json_data
      })
      .then(response => {
        toastr.success('Su Usuario ha sido ingresado con éxito.', 
                       "ÉXITO", {"iconClass": 'customer-success'});
                       this.mensaje = "Usted ha sido registrado correctamente";
                       this.mensaje_error = "";
                       //iniciando sesión
                       this.login(json_data.nick_client,json_data.password_client);
                        this.reset_view();   
      })
      .catch(error => {
        console.log(error.response.data.details);
        if(error.response.status === CONFLICT){
          this.mensaje_error = "El nombre de usuario o el e-mail que desea registrar ya existe en la base de datos.";
        }
        else if(error.response.status === BAD_REQUEST){
          this.mensaje_error = "Ingrese correctamente los datos solicitados.";
        }
        else if(error.response.status === NOT_FOUND){
          this.mensaje_error = "Se ha producido un error. Inténtelo nuevamente.";
        }
        this.mensaje = "";
                       
      })

     
      this.showLoader = false;
    },

    reset_view() {
      this.showLoader = false,
      this.client_email = "",
      this.client_username = "",
      this.client_password = "",
      this.client_name = "",
      this.client_lastname = "",
      this.client_dni = "",
      this.cliente_phone = "",
      this.cboDepartamento = "",
      this.cboProvincia = "",
      this.cboDistrito = "",
      this.client_address = "",
      this.cboDepartamento = "",
      this.cboProvincia = "",
      this.cboDistrito = "",
      this.isdisabled = true,
      this.isdisabled_distrito = true,
      this.isdisabled_direccion = true
    },

    callDepartamentos () {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL+'/GET/locations/departments',
      })
      .then(response => {
        this.depas_array = response.data
      })
      .catch(error => {
        console.log(error); 
      })
    },

    callProvincias (cboDepartamento) {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL+'/GET/locations/departaments/'+cboDepartamento+'/provinces',
      })
      .then(response => {
        this.province_array = response.data
        this.cboProvincia = ""
        this.cboDistrito = ""
        this.isdisabled = false
        this.isdisabled_distrito = true
        this.txtDireccion = ""
        this.isdisabled_direccion = true
      })
      .catch(error => {
         console.log(error);
      })
    },

    callDistritos (cboProvincia) {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL+'/GET/locations/departments/provinces/'+cboProvincia+'/districts',
      })
      .then(response => {
        this.distrito_array = response.data
        this.cboDistrito = ""
        this.isdisabled_distrito = false
      })
      .catch(error => {
        console.log(error);  
      })
    },

    enableDireccion(){
      this.isdisabled_direccion = false;
    },

    ocultar(){
       this.mensaje=""
       this.mensaje_error=""
    }
  }
};
</script>

<style>
.form-signup {
  width: 100%;
  max-width: 500px;
  padding: 15px;
  margin: auto;
}

.hrdivider {
  position: relative;
  margin-bottom: 20px;
  width: 100%;
  text-align: center;
}

.hrdivider span {
  position: absolute;
  top: -11px;
  background: #fff;
  padding: 0 20px;
  font-weight: bold;
  font-size: 16px;
}
</style>
